"use client";

import styled from "styled-components";
import { accentColorDanger } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyRequiredIndicator = styled(Text4).withConfig({
  componentId: "sc-qftkq7-0"
})(["color:", ";"], accentColorDanger);
const RequiredIndicator = props => /*#__PURE__*/_jsx(InternalUseOnlyRequiredIndicator, {
  renderAs: "span",
  ...props,
  children: "*"
});
RequiredIndicator.displayName = "RequiredIndicator";
export default RequiredIndicator;